import React from "react";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ClosePopupIcon from "../../../assets/icons/close-new.svg";
import AccountIcon from "../../../assets/icons/account-preference.svg";
import { Overlay } from "../../../components";
import { motion } from "framer-motion";
import ChangePassword from "./ChangePassword";
import { AppBar, Box, Drawer, Toolbar } from "@mui/material";
import NotificationPreference from "./NotificationPreference";

const drawerWidth = 152;

const AccountPreferences = ({ openModal, onClose, userDetails }) => {
  const [renderChangePassword, setRenderChangePassword] = React.useState(false);
  const [renderNotification, setRenderNotification] = React.useState(false);
  const [modalMiddle, setModalMiddle] = React.useState(true);

  const handleRenderChangePassword = () => {
    setRenderChangePassword(true);
    setRenderNotification(false);
    setModalMiddle(!modalMiddle);
  };

  const handleRenderNotification = () => {
    setRenderNotification(true);
    setRenderChangePassword(false);
    setModalMiddle(false);
  };

  const closeModal = () => {
    onClose();
    setModalMiddle(true);
    setRenderNotification(false);
    setRenderChangePassword(false);
  };

  return (
    openModal && (
      <React.Fragment>
        <Overlay />
        <div className="modal_big">
          <div className="prompt-preferences">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Box sx={{ display: "flex", maxHeight: "465px" }}>
                <CssBaseline />

                <AppBar
                  position="fixed"
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: "#fff" }}
                >
                  <Toolbar className="prompt-top">
                    <div className="prompt-title">
                      <img style={{ marginLeft: "-3px" }} src={AccountIcon} alt={"account"} />
                      <span style={{ color: "#0F0DA1", fontSize: "16px", marginLeft: "10px", fontWeight: "700" }}>
                        Account Preferences
                      </span>
                    </div>
                    <img
                      className="close-icon"
                      src={ClosePopupIcon}
                      onClick={() => {
                        onClose(closeModal);
                        setRenderChangePassword(false);
                      }}
                    />
                  </Toolbar>
                </AppBar>

                <Drawer
                  variant="permanent"
                  sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    backgroundColor: "#ffffff",
                    "& .MuiDrawer-paper": { width: drawerWidth },
                  }}
                >
                  <Toolbar />
                  <Box sx={{ overflow: "auto" }}>
                    <List>
                      {["Change Password"].map((text, index) => (
                        <ListItem button key={text}>
                          <ListItemText
                            primary={text}
                            onClick={handleRenderChangePassword}
                          />
                          <Divider />
                        </ListItem>
                      ))}

                      <ListItem button>
                        <ListItemText
                          primary="Notifications"
                          onClick={handleRenderNotification}
                        />
                        <Divider />
                      </ListItem>
                    </List>
                  </Box>
                </Drawer>

                <Box
                  component="main"
                  sx={{ flexGrow: 1, p: 3, alignContent: "center" }}
                >
                  <Toolbar />
                  <div className="modal_middle">
                    {(renderChangePassword || modalMiddle) && (
                      <div className="d-flex justify-content-between box-sizing">
                        <div className="change-password">
                          <ChangePassword
                            userDetails={userDetails}
                            onClose={closeModal}
                          />
                        </div>
                        <div className="password-hints">
                          <p className="must-Contain">Password must contain:</p>
                          <div className="hints">
                            <p>At least 1 upper case letter (A-Z)</p>
                            <p>At least 1 number (0-9)</p>
                            <p>At least 8 characters</p>
                          </div>
                        </div>
                      </div>
                    )}
                    {renderNotification && (
                      <NotificationPreference
                        userDetails={userDetails}
                        onClose={handleRenderNotification}
                        closeModal={closeModal}
                      />
                    )}
                  </div>
                </Box>
              </Box>
            </motion.div>
          </div>
        </div>
      </React.Fragment>
    )
  );
};

export default AccountPreferences;
